/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  SET_JSON_RESPONSE(state, payload) {
    state.json_response = payload;
  },
  SET_CONFIRM_SYNC(state, payload) {
    state.confirmSync = payload;
  },
  REMOVE_JSON_RESPONSE(state) {
    // const userIndex = state.users.findIndex((u) => u.id === itemId)
    state.json_response = null;
  },
  // if resume is parsed by admin for invitation then user data will be
  SET_USER_JSON_RESPONSE(state, payload) {
    state.userJsonResponse = payload;
  },
};
